

<div  *ngIf="processSubject | async" class="full-width">

    <div class="flex-column gap-standard border-gray-bottom full-width padding-standard">

        <h5 *ngIf="showTitle" class="margin-none mat-headline-4 ">{{(processSubject | async).description}}</h5>
        <div    class="gap-small flex-wrap flex--align-start" 
                [ngClass]="{
                    'flex-row':!(smallScreenObs | async),
                    'col-width-2':!(smallScreenObs | async),
                    'flex-column':smallScreenObs | async
                }"
        >   
        
        <div class="flex-1 flex-column gap-small">
            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('creator') | async"
            
                [fieldInfo]="getFieldInfoObs('creator') | async"
            ></ss-process-review-field>
            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('created') | async"
            
                [fieldInfo]="getFieldInfoObs('created') | async"
            ></ss-process-review-field>
            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('validTill') | async"
            
                [fieldInfo]="getFieldInfoObs('validTill') | async"
            ></ss-process-review-field>
            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('note') | async"
            
                [fieldInfo]="getFieldInfoObs('note') | async"
            ></ss-process-review-field>
        </div>
        <div class="flex-1 flex-column gap-small">
            <ss-process-review-field 
                *ngIf="getFieldInfoVisibleObs('status') | async"

                [fieldInfo]="getFieldInfoObs('status') | async"
            ></ss-process-review-field>
            <ss-process-review-field 
                *ngIf="getFieldInfoVisibleObs('processSharingType') | async"

                [fieldInfo]="getFieldInfoObs('processSharingType') | async"
            ></ss-process-review-field>
            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('statusChanged') | async"
                [fieldInfo]="getFieldInfoObs('statusChanged') | async"
            ></ss-process-review-field>

            <ss-process-review-field
                *ngIf="getFieldInfoVisibleObs('statusChangedReason') | async"
                [fieldInfo]="getFieldInfoObs('statusChangedReason') | async"
            ></ss-process-review-field>
        </div>
            

            
        
        </div>
        
    </div>

    <div class="padding-standard">
        <div class="display-block border-gray border-radius-small">
            <ss-process-review-activity 
                class="display-block"
                *ngFor="let activity of activitiesSubject | async;let idx = index" [activity]="shallowClone(activity)"
                [ngClass]="{'border-gray-top':!!idx}"
            ></ss-process-review-activity>
        </div>
    </div>
    
</div>